/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import { DropdownButton, NavItem } from "react-bootstrap";
import { IoFolder, IoTrash, IoEllipsisVertical } from "react-icons/io5";

import ReactTable from "react-table";

import ResponsiveDataComponent from "../../common/ResponsiveDataComponent";

import { formatDate } from "../../../helpers/date";

import { formatCurrency } from "@redkeep/utils";

const PurchaseOrderList = ({
  contract,
  isMobile,
  onClickDelete,
  onClickEdit
}) => {
  const columns = !isMobile
    ? [
        {
          Header: "Invoice Number",
          accessor: "invoice_number",
          maxWidth: 150
        },
        {
          Header: "Invoice Date",
          accessor: "invoice_date",
          Cell: (row) => <span>{formatDate(row.value, "MM/dd/yyyy")}</span>
        },
        {
          Header: "Billing Rate",
          accessor: "billing_rate",
          Cell: (row) => (row.value ? formatCurrency(row.value) : "--")
        },
        {
          Header: "Hours Purchased",
          accessor: "hours_purchased",
          Cell: (row) => (row.value ? row.value.toFixed(2) : "--")
        },
        {
          Header: "Amount",
          accessor: "amount",
          Cell: (row) => (row.value ? formatCurrency(row.value) : "--")
        },
        {
          Header: "PO Number",
          accessor: "po_number",
          Cell: (row) => (row.value ? row.value : "--"),
          maxWidth: 150
        },
        {
          Header: "Notes",
          accessor: "notes",
          minWidth: 150
        }
      ]
    : [
        {
          Header: "Billing Rate",
          accessor: "billing_rate",
          Cell: (row) => (row.value ? formatCurrency(row.value) : "--")
        },
        {
          Header: "Hours Purchased",
          accessor: "hours_purchased",
          Cell: (row) => (row.value ? row.value.toFixed(2) : "--")
        }
      ];

  columns.push({
    Header: "",
    accessor: "_id",
    maxWidth: 80,
    sortable: false,
    Cell: (row) => (
      <div className="text-center actions">
        <DropdownButton
          title={
            <span>
              <IoEllipsisVertical />
            </span>
          }
          id="dropdown"
        >
          <NavItem onClick={() => onClickEdit(row.original)}>
            <IoFolder />
            View
          </NavItem>
          <NavItem onClick={() => onClickDelete(row.value)}>
            <IoTrash />
            Delete
          </NavItem>
        </DropdownButton>
      </div>
    )
  });

  const purchaseOrders = contract.purchase_orders;

  return (
    <ReactTable
      className="-highlight"
      data={purchaseOrders}
      columns={columns}
      showPagination={purchaseOrders && purchaseOrders.length >= 10}
      defaultPageSize={10}
      getTdProps={(state, rowInfo, column) => ({
        onClick: () => {
          if (column.id !== "_id" && rowInfo?.original) {
            onClickEdit(rowInfo.original);
          }
        }
      })}
      SubComponent={
        isMobile
          ? (row) => (
              <ResponsiveDataComponent
                data={[
                  { key: "PO Number", label: row.original.po_number },
                  { key: "Invoice Number", label: row.original.invoice_number },
                  {
                    key: "Invoiced Date",
                    label: formatDate(row.original.invoiced_date, "MM/dd/yyyy")
                  },
                  {
                    key: "Billing Rate",
                    label: row.original.billing_rate
                      ? formatCurrency(row.original.billing_rate)
                      : "--"
                  },
                  {
                    key: "Hours Purchased",
                    label: row.original.hours_purchased
                      ? row.original.hours_purchased.toFixed(2)
                      : "--"
                  },
                  {
                    key: "Amount",
                    label: row.original.amount
                      ? formatCurrency(row.original.amount)
                      : "--"
                  },
                  { key: "Notes", label: row.original.notes }
                ]}
              />
            )
          : false
      }
    />
  );
};

PurchaseOrderList.propTypes = {
  contract: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  onClickDelete: PropTypes.func,
  onClickEdit: PropTypes.func
};

export default PurchaseOrderList;
